<div class="spinner-cover" [class.hidden]="!loading"></div>
<div class="spinner" [class.hidden]="!loading">
    <div class="double-bounce1"></div>
    <div class="double-bounce2"></div>
</div>
<router-outlet></router-outlet>
